// ------------------------OPT------------------------------- //
//var base_url = 'http://test.api.platform.winlesson.com' //测试
var base_url =  'https://api.web.platform.winlesson.com'

export default {
  base_url : base_url, // 兼容……
  getapplication: base_url+ '/api/h5_share/application/app_info',
  // 首页：
  index: base_url + '/content/operation/list', // 课程首页分类列表-GET
  by_page: base_url + '/content/operation/list/by_page', //课程首页分类页面数据-GET
  course_list: base_url + '/course/info/list', //课程课程筛选列表-GET
   // 用户登录接口：
  loginmima: base_url + '/user/login', //登录-POST
  login: base_url + '/api/user/v5/login/by_verify_code', //手机号码验证码登录V5 - ~-POST
  register: base_url + '/user/register/by_phone', //注册-POST
  get_verify_code: base_url + '/user/get/phone/verify_code', //获取验证码-POST  停用被刷
  web_verify_code: base_url + '/user/get/phone/web/verify_code', //获取验证码-POST
  reset: base_url + '/user/password/reset', // 重置密码-POST
  list_by_id: base_url + '/user/course/list/by_id', // 查询用户是否购买过此课程-GET

  // 视频：
  course_detail: base_url + '/course/info/detail', //课程简介-GET
  course_videos: base_url + '/api/course/v5/chapter/item_list', //视频列表-GET
  course_videos_vip: base_url + '/course/chapter/vip/videos', //视频列表-GET
  live_status: base_url + '/api/bskgk/video/live_status', //直播状态请求-POST
  add_video_record: base_url +'/api/bskgk/course/record/add',  //提交课程播放历史-api.msg.platform.winlesson.com-POST
  // 互动：
  getChatList: base_url + '/api/bskgk/chat', // 获取评论列表-POST
  postChat:base_url + '/api/bskgk/chat/release', // 发送评论-POST

   //支付和订单：
  create_order: base_url + '/api/pay/order_id/create', //创建订单
  confirm_order: base_url + '/api/pay/order/update', //确认订单
  wxcode: base_url + '/api/wx/qrcode', //微信支付：生成二维码
  alicode: base_url + '/api/live/ali/wap/do/pay', //阿里支付：生成二维码
  change_address: base_url + '/api/bskgk/order/address/add', //更改收货地址
  add_to_mycourse: base_url + '/api/bskgk/course/subscribe', //添加到我的课程-POST(免费课程)
  create_order_by_code: base_url + '/api/pay/order/code/create', //优惠码创建订单

  //个人中心
  set_info: base_url + '/user/info/set', // 更新用户基本信息-POST
  my_course: base_url + '/api/bskgk/user/my_course/by_category', // 我的课程-POST
  get_voucher_list: base_url + '/api/user/voucher', // 获取优惠券
  get_balance: base_url + '/user/account/balance', // 获取余额
  get_orders: base_url + '/api/bskgk/v3/user/orders', //我的订单

  //资讯
  infomation_list: base_url + '/info/list', //资讯
  infomation_list_home: base_url + '/api/information/v6/article_list',
  infomation_list_by_type: base_url + '/api/information/v6/article_list/by_category', //分类资讯

  //模考
  dry_practice_list: base_url + '/api/bskgk/v2/exam/practice',// 模考列表 GET
  dry_join: base_url + '/api/bskgk/v2/exam/practice/join',// 参加模考 POST
  dry_mine: base_url + '/api/bskgk/v2/exam/practice/mine',// 我的模考 GET
  dry_all_detail: base_url + '/api/bskgk/subject/mock/exam/all/detail',// 模考试卷详情 GET
  dry_analysis: base_url + '/api/bskgk/subject/analysis',//获取题目解析 POST
  dry_submit: base_url + '/api/bskgk/subject/exam/mock/submit',// 模考交卷 POST
  dry_result: base_url + '/api/bskgk/subject/past/exam/new/result',// 模考报告 POST
  dry_server_time: base_url + '/api/bskgk/mock/server_time',// 模考服务器时间 GET

  //问答
  get_quiz_list:base_url + '/api/question/v5/item_list/by_category',
  get_quiz_detail:base_url + '/api/bskgk/v2/question/detail',
  get_quiz_comment_list:base_url + '/api/bskgk/v2/question/review',
  upload_article_read:base_url + '/info/article/read',
  get_my_quiz_list:base_url + '/api/bskgk/v2/question/my_question_new'
}
// ------------------------LIB------------------------------- //
// 获取URL参数
function getQueryString(name, str) {
  var s = str || window.location.search;
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  var r = s.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
  // 这样调用：
  //alert(GetQueryString("参数名1"));
}

// 阻止默认事件
function stopDefault(e) {
  //阻止默认浏览器动作(W3C)
  if (e && e.preventDefault) e.preventDefault();
  //IE中阻止函数器默认动作的方式
  else window.event.returnValue = false;
  return false;
}



// WEBPACK FOOTER //
// ./src/common/js/urls.js